export const postRequestcall = async (apiurl, access_token, payload) => {
  try {
    let callPostrequest;
    let headers = new Headers();
    if (
      typeof access_token !== "undefined" &&
      access_token !== null &&
      access_token !== ""
    ) {
      headers.append("Authorization", `Bearer ${access_token}`);
    }
    headers.append("Content-Type", "application/json");
    headers.append("Accept", "application/json");
    if (payload === "") {
      callPostrequest = await fetch(
        `${process.env.REACT_APP_BASE_URL}/${apiurl}`,
        {
          headers,
          method: "POST",
        }
      );
    } else {
      callPostrequest = await fetch(
        `${process.env.REACT_APP_BASE_URL}/${apiurl}`,
        {
          headers,
          method: "POST",
          body: JSON.stringify(payload),
        }
      );
    }
    return callPostrequest;
  } catch (error) {}
};
